const media = {
  desktop: `@media (max-width: ${992}px)`,
  tablet: `@media (max-width: ${768}px)`,
  phone: `@media (max-width: ${576}px)`,
};

export default media;
